import { useEffect, useEffectEvent } from 'react';

export function useSyncPaginationTotal(
    updateTotalAndPagination: (value: number | undefined) => void,
    value: number | undefined,
): void {
    const updateTotalAndPaginationEvent = useEffectEvent(updateTotalAndPagination);

    useEffect(() => {
        updateTotalAndPaginationEvent(value);
    }, [value]);
}
